import restTypes from '../utils/rest/types';
import restStates from '../utils/rest/states';
import restInitState from '../utils/rest/initState';

const initialState = {};
const eventMessageTypeRestTypes = restTypes('event_message_type');

export default (state = { ...restInitState, ...initialState }, action = {}) => {
  switch (action.type) {
    case eventMessageTypeRestTypes.searchAllStart:
      return {
        ...state,
        ...restStates.searchAllStart,
      };
    case eventMessageTypeRestTypes.searchAllFinished:
      return {
        ...state,
        ...restStates.searchAllFinished,
        ...action.payload,
      };
    case eventMessageTypeRestTypes.clearFromStateFinished:
      return {
        ...state,
        ...restStates.clearFromStateFinished,
        ...action.payload,
      };
    default: return state;
  }
};
